import React from 'react';
import { Copy, Flex, Stack, SvgInfo } from '@grubhubprod/gh-cookbook-react';
import { Tooltip } from 'src/components/Tooltip/Tooltip';

export interface CustomLabelWithTooltipProps {
  labelText: string;
  tooltipInfo: JSX.Element;
  color?: string;
}

export const CustomLabelWithTooltip = ({
  labelText,
  tooltipInfo,
  color = 'secondaryText',
}: CustomLabelWithTooltipProps): JSX.Element => {
  return (
    <Flex alignItems="flex-end">
      <Stack x="xxx-sm">
        <Copy variant="body" color={color}>
          {labelText}
        </Copy>
      </Stack>

      <Tooltip
        maxWidth="290px"
        roundedContainer
        content={tooltipInfo}
        interactive
      >
        <Stack as="span">
          <Copy variant="body" color={color}>
            <SvgInfo aria-label="tooltip info" size="20px" />
          </Copy>
        </Stack>
      </Tooltip>
    </Flex>
  );
};
